import React,{Component} from 'react';
import Relay from 'react-relay';
import cookie from '../../helper/cookie'

class Usersettings extends Component
{

constructor(props)
{
  super(props);
  var gender;
  if (this.props.viewer.picture == "http://dndw32r4edmw5.cloudfront.net/avatar/Male.png") {
    gender = "male"
  }
  else if (this.props.viewer.picture == "http://dndw32r4edmw5.cloudfront.net/avatar/Female.png") {
    gender = "female"
  }
  this.state={
    gender:gender,
    name:this.props.viewer.name,
    email:this.props.viewer.email,
    pid:this.props.viewer.pid,
    err:"",
  };
  this.submitted=this.submitted.bind(this);
  this.typeCheck=this.typeCheck.bind(this);
}
typeCheck(type)
{
  this.setState({gender:type});
}
submitted()
{

  var params = JSON.stringify({
      "name": this.refs.name.value,
      // "gender": this.refs.pwrd.value
    });
  var url = 'http://surveymate-io.herokuapp.com/api/users/' + this.state.pid;
  var responseCode;
  var responseText;
  var self=this;
  // console.log(params);
  var response = fetch(url, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: params
  }).then(function (response) {
      responseCode = response.status;
      responseText = response.statusText;
      return response.text();
  }).then(function (result) {
      var jsonData = JSON.parse(result);
      if (responseCode == 200) {
        window.location.href = "/#/admin/" + self.state.pid;
      }
      else {
        alert("Some Error ! Please try again after some time.");
      }
  }).catch(function (error) {
    console.error('An error occured');
    console.error(error);
  });

}
render()
  {

    var st={
  					vert: {
  						verticalAlign:'bottom',
  					},
  					noborder:{
  						border:'none',
  					},
            panel:{
            	height:600,
            	backgroundColor:"#ffffff",
            	borderTopRightRadius:0,
            	borderTopLeftRadius:0,
    					border:'none',
    					overflow:"auto",
    					height:550,
  					},

  					background:{
  						backgroundColor:"#fbfbfb",
  						height:900,
  					},

  					noborderback:{
  						border:'none',
  						backgroundColor:"#fbfbfb",
  					},
  					thickline:{
          	height:"11.1px",
          	backgroundColor:"#1a84eb",
          	borderBottomRightRadius:0,
          	borderBottomLeftRadius:0,
        },

  					scroll_div:{
  						border:'none',
  						overflow:"auto",
  						height:550,

  					},

  					inputBox:{
  						wordWrap:"break-word",
  						height:62,
  						width:768,

  					},

  					heading:{
  						paddingTop:"20",
  						paddingBottom	:"20",

  					},

  					pad:{
  						paddingTop:5,
  						paddingBottom:5,
  						paddingRight:0,
  						paddingLeft:0,
  					},
  					padder:{
  						paddingTop:50,
  					},
  					radioButton:{
  						paddingTop:5,
  						paddingBottom:5,
  						paddingRight:5,
  						paddingLeft:0,
  					},
  					backgroundButton:{
  						backgroundColor:"#1a84eb",
  					},
            in:{
              height: "50px",
              borderRadius: "5px",
            },
            bttIn:{
              height: "50px",
              borderTopRightRadius:"0px",
              borderBottomRightRadius:"0px",
              borderTopLeftRadius: "5px",
              borderBottomLeftRadius: "5px",
            },
            numIn:{
              height: "50px",
              borderTopRightRadius:"5px",
              borderBottomRightRadius:"5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
            },

  				};

    if (cookie.get('access_token') != null) {
    return(
      <div>
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <h1 className="text-center">Your Profile</h1>
          <form role="form">
            <div className="form-group" >
              <label htmlFor="usr">NAME</label>
              <input type="text" className="form-control" id="usr" ref="name" style={st.in} defaultValue={this.state.name}/>
            </div>
            <fieldset disabled>
            <div className="form-group">
              <label htmlFor="disabledTextInput" classNAme="control-label">Primary E-mail</label>
              <div>
                <input type="text" id="disabledTextInput" className="form-control" style={st.in} placeholder={this.state.email} />
              </div>
              </div>
            </fieldset>
          </form>

          <div  style={st.heading}>
            <h5 ><strong>AVATAR</strong></h5>
          </div>
          <RadioButtonGroup handleType={this.typeCheck} />
          <ValidatePassword data={this.props.viewer} />
          <div className="row">
            <div className="col-md-6">
              <div style={st.padder}>
                <button type="button" className="btn btn-primary btn-lg pull-left" data-toggle="modal" data-target="#demo" style={st.backgroundButton} >Change Password</button>
              </div>
            </div>
            <div className="col-md-6">
              <div style={st.padder}>
                <button type="button" className="btn btn-primary btn-lg pull-right" style={st.backgroundButton} onClick={this.submitted}>Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

class ValidatePassword extends Component{
  constructor(props)
  {
      super(props);
      this.state={error:false,valid:false,something:false,clicked:false,resetError:false,reset:false};
      this.pwdCheck=this.pwdCheck.bind(this);
      this.validPwd=this.validPwd.bind(this);

  }

  validPwd()
  {  
    var self=this;
    if(self.refs.oldpwd.value=="" || self.refs.rnpd.value=="" || this.state.error)
    {
        self.setState({something:false,clicked:true});
    }
    else {
      var params = JSON.stringify({
        "email": this.props.data.email,
        "password": this.refs.oldpwd.value
      });
      var url = 'http://surveymate-io.herokuapp.com/api/users/login';
      var responseCode;
      var responseText;
      // console.log(params);
      var response = fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: params
      }).then(function (response) {
          responseCode = response.status;
          responseText = response.statusText;
          return response.text();
      }).then(function (result) {
          // var jsonData = JSON.parse(result);
          if (responseCode == 200) {
            self.setState({something:true,clicked:true,valid:true});
            var userId=self.props.data.pid
            var params = JSON.stringify({
              "password": self.refs.rnpd.value
            });
            var url = 'http://surveymate-io.herokuapp.com/api/users/'+userId;
            var Code;
            var Text;
            // console.log(params);
            var response = fetch(url, {
              method: 'PUT',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: params
            }).then(function (response) {
                Code = response.status;
                return response.text();
            }).then(function (result) {
                // var jsonData = JSON.parse(result);
                if (Code == 200) {
                  self.setState({reset:true,resetError:false});
                }
                else {
                  self.setState({reset:false,resetError:true});
                }
            }).catch(function (error) {
              console.error('An error occured');
              console.error(error);
            });
          }
          else {
            self.setState({something:true,clicked:true,valid:false});
          }
      }).catch(function (error) {
        console.error('An error occured');
        console.error(error);
      });
    }
  }

  pwdCheck()
  {
    var new_pd=this.refs.rnpd.value.trim();
    var old_pd=this.refs.npd.value.trim();
    if(new_pd!=old_pd) {
      this.setState({error:true});
    }
    else {
      this.setState({error:false});
    }

  }

  render()
  {
    var st={
      in:{
        height: "50px",
        borderRadius: "5px",
      },
    }
    var emessage="",valmessage="",modval="";

    if(this.state.error)
    {
      emessage="Both new passwords must match."
    }

    if(this.state.something==false)
    {
      modval="";
      if(this.state.clicked)
        valmessage="Please enter all the fields appropriately";
      else
        valmessage="";
    }
    else {
        if(this.state.valid)
        {
          modval="modal";
        }
        else {
          modval="";
          valmessage="Old password is incorrect";
        }
    }
    var reset=""
    if(this.state.reset){
      reset=<div className="text-success">Password changed successfully</div>
    }
    var resetError=""
    if(this.state.resetError){
      resetError=<div className="text-danger">Some error. Try again after some time</div>
    }
    return(
      <div id="demo" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>
            <div className="modal-body">
              {reset}
              {resetError}
              <p className="text-danger">{valmessage}</p>
              <div className="form-group">
                  <label htmlFor="sel1">ENTER OLD PASSWORD:</label>
                  <input type="password" className="form-control" id="usr" ref="oldpwd" style={st.in} />
              </div>
              <div className="form-group">
                <label htmlFor="sel1">ENTER NEW PASSWORD:</label>
                <input type="password" className="form-control" id="usr" ref="npd" style={st.in}  />
              </div>
              <p className="text-danger">{emessage}</p>
              <div className="form-group">
                <label htmlFor="sel1">RETYPE PASSWORD:</label>
                <input type="password" className="form-control" id="usr" ref="rnpd" style={st.in} onChange={this.pwdCheck}/>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss={modval} onClick={this.validPwd}>Done</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

class RadioButtonGroup extends Component {
  constructor(props){
    super(props);
    this.state={
      left:true,
      right:false,
    };
    this.leftClick=this.leftClick.bind(this);
    this.rightClick=this.rightClick.bind(this);
  }
  leftClick(){
    this.setState({left:true,right:false});
    this.props.handleType("male");
  }
  rightClick(){
    this.setState({left:false,right:true});
    this.props.handleType("female");
  }
  render(){
    var st={
      lbtn:{
        width: '28px',
        height: '28px',
        borderRadius:'14px',
        backgroundColor:'#d9d9d9',
      },
      rbtn:{
        width: '28px',
        height: '28px',
        borderRadius:'14px',
        backgroundColor:'#d9d9d9',
      },
      limg:{
        backgroundColor:'#ffffff',
      },
      rimg:{
        backgroundColor:'#ffffff',
      },

    };
    var left,right;
    if(this.state.left){
      st.lbtn.backgroundColor='#e6f2ff';
      st.limg.backgroundColor='#e6f2ff';
      left=<button type="button" className="btn" style={st.lbtn} onClick={this.leftClick}></button>
    }else {
      st.lbtn.backgroundColor='#d9d9d9';
      st.limg.backgroundColor='#d9d9d9';
      left=<button type="button" className="btn" style={st.lbtn} onClick={this.leftClick}></button>
    }
    if(this.state.right){
      st.rbtn.backgroundColor='#e6f2ff';
      st.rimg.backgroundColor='#e6f2ff';
      right=<button type="button" className="btn" style={st.rbtn} onClick={this.rightClick}></button>
    }else {
      st.rbtn.backgroundColor='#d9d9d9';
      st.rimg.backgroundColor='#d9d9d9';
      right=<button type="button" className="btn" style={st.rbtn} onClick={this.rightClick}></button>
    }
    return(
      <div>
        <div className="row">
          <div className="col-md-2 text-center">
            <img src="http://dndw32r4edmw5.cloudfront.net/avatar/Male.png" width="80" height="80" className="img-circle img-responsive" style={st.limg}/>
          </div>
          <div className="col-md-2 text-center">
            <img src="http://dndw32r4edmw5.cloudfront.net/avatar/Female.png" width="80" height="80" className="img-circle img-responsive" style={st.rimg}/>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-2" style={{paddingLeft:'40px',}}>
            {left}
          </div>
          <div className="col-md-2" style={{paddingLeft:'40px',}}>
            {right}
          </div>
        </div>
      </div>
    );
  }
}

export default Relay.createContainer(Usersettings, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Agent {
        name
        pid
        picture
        email
      }
    `
  }
});



/** WEBPACK FOOTER **
 ** ./src/views/Profile/index.js
 **/